/**
 * @author: Angel Labrada Massó
 * @since v0.0.1
 * @date 8/5/22
 */
import React, {memo} from 'react';
import PropTypes from 'prop-types';
import {Card, Row, Col, InputNumber} from 'antd';
import classNames from 'classnames';
import {useTranslation} from 'react-i18next';
import styles from './index.less';

const PreviewNumberType = ({parameter}) => {
  const {t} = useTranslation('templates');

  return (
    <Card className={styles.card}>
      <Row gutter={[16,16]} className="flex items-center justify-center">
        <Col span={6}>{parameter?.parameter?.name || parameter?.parameter?.label}</Col>
        <Col span={18} className={styles.wrapperInputNumber}>
          <InputNumber
            size="large"
            placeholder={t('placeholderNumber')}
            style={{borderRadius: '5px'}}
            className="w-full"
            addonAfter={
              <span className="ant-input-suffix">
                <span role="img" aria-label="font-size"
                  className="anticon anticon-font-size"
                >
                  <div className={classNames('flex items-center justify-center icon-response', styles.icon, styles.iconNumber)}>123</div>
                </span>
              </span>
            }
          />
        </Col>
      </Row>
    </Card>
  );
};

PreviewNumberType.propTypes = {
  parameter: PropTypes.object
};

export default memo(PreviewNumberType);
